export default __webpack_public_path__ + "static/young-toddler6-92c3a2e5c877fd78ea0be944e3601335.jpg";